import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from '../services/api.service';
import { TranslateService } from '../services/translate.service';

@Component({
  selector: 'app-monthly-payroll-expense',
  templateUrl: './monthly-payroll-expense.component.html',
  styleUrls: ['./monthly-payroll-expense.component.scss']
})
export class MonthlyPayrollExpenseComponent {

  monthYear: string = '';
  report: any = null;
  loadingReport = false;
  generatingExpense = false;

  constructor(
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  viewReport(): void {
    if (!this.monthYear) {
      this.snackBar.open(this.translate.t('SELECT_MONTH_FIRST'), 'Close', { duration: 3000 });
      return;
    }
    this.loadingReport = true;
    this.apiService.getMonthlyWageReport(this.monthYear).subscribe(
      data => {
        this.report = data;
        this.loadingReport = false;
      },
      err => {
        this.loadingReport = false;
        const msg = err?.error?.message || this.translate.t('FAILED_LOAD_MONTHLY_REPORT');
        this.snackBar.open(msg, 'Close', { duration: 4000 });
      }
    );
  }

  generateExpense(): void {
    if (!this.monthYear) {
      this.snackBar.open(this.translate.t('SELECT_MONTH_FIRST'), 'Close', { duration: 3000 });
      return;
    }
    this.generatingExpense = true;
    this.apiService.generateMonthlyWageExpense(this.monthYear).subscribe(
      data => {
        this.generatingExpense = false;
        this.report = data?.report || this.report;
        const msg = data?.message || this.translate.t('MONTHLY_EXPENSE_GENERATED');
        this.snackBar.open(msg, 'Close', { duration: 4000 });
      },
      err => {
        this.generatingExpense = false;
        const msg = err?.error?.message || this.translate.t('FAILED_GENERATE_MONTHLY_EXPENSE');
        this.snackBar.open(msg, 'Close', { duration: 4000 });
      }
    );
  }
}
